import { DECREASE, INCREASE } from "../cart/actionTypes";
import cartReducer from "../cart/cartReducer";

const myLogger = (store) => (next) => (action) => {
    const upcomingState = [action].reduce(cartReducer, store.getState());

    //If the product quantity is greater or equal 0. Then update the state otherwise don't update.
    if (action.type === INCREASE) {
        upcomingState?.products?.map((product) => {
            if (product.id === action?.payload?.id && product?.quantity >= 0) {
                return next(action);
            } else {
                return null;
            }
        });
    }

    //If the item quantity is greater than 1. Then update the state otherwise don't update.
    if (action.type === DECREASE) {
        const state = store.getState();
        state.carts.map((cart) => {
            if (cart?.id === action?.payload?.id && cart?.quantity > 1) {
                return next(action);
            } else {
                return null;
            }
        });
    }
};

export default myLogger;
